import React from 'react';
import styled from 'styled-components';
import { toFriendlyDateTimeString } from 'helpers/Formatter';
import { getCurrentLocale } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';

const EventWrapper = styled.div`
  margin-bottom: 1rem;
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.mobile`
    display: block;
  `};
`;

const Title = styled.div`
  font-family: 'Circular-Bold';
`;

const Date = styled.div`
  font-size: 13px;
  font-family: 'Circular-Bold';
  color: grey;
  min-width: 200px;
  text-align: right;

  ${media.mobile`
    text-align: left;
  `};
`;

const Verbiages = styled.div`
  padding-left: 1.5rem;
  color: grey;
  font-size: 13px;
`;

const Bullet = styled.span`
  font-size: 30px;
  line-height: 0;
  position: relative;
  top: 4px;
`;

const Event = ({ time, verbiage }) => {
  let firstVerbiage = verbiage;
  let restOfDetails = [];

  // To ensure we are only using the spread operator on arrays and not strings
  // verbiage = "String"  => firstVerbiage = "S", restOfDetails = ["t","r","i","n","g"]
  if (Array.isArray(verbiage)) {
    [firstVerbiage, ...restOfDetails] = verbiage;
  }

  return (
    <EventWrapper>
      <TitleRow>
        <Title>
          <Bullet>&bull;</Bullet> {firstVerbiage}
        </Title>
        <Date>{toFriendlyDateTimeString(time, { language: getCurrentLocale() })}</Date>
      </TitleRow>
      <Verbiages>{restOfDetails.map(msg => <div>{msg}</div>)}</Verbiages>
    </EventWrapper>
  );
};

export default Event;
